import * as React from 'react';
export const chevronRightSvg = React.forwardRef(function chevronRightSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.334.606a.75.75 0 0 1 1.06-.022l3 2.875a.75.75 0 0 1 0 1.082L3.4 7.416a.75.75 0 1 1-1.038-1.082L4.79 4 2.357 1.666a.75.75 0 0 1-.022-1.06Z',
    }),
  );
});
chevronRightSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronRight = {
  category: 'icon',
  colorable: true,
  name: 'chevronRight',
  svg: chevronRightSvg,
};
